import React from 'react';
import { FormattedMessage, injectIntl, IntlShape } from 'react-intl';

import { Button } from 'views/components/Button/Button';

interface IProps {
  message?: string;
  is404: boolean;
  intl: IntlShape;
}

const ErrorPageComponent = ({ message, is404, intl }: IProps) => (
  <div className="Container">
    <div className="ErrorPage">
      <div className="ErrorPage-content">
        <h2 className="ErrorPage-heading">
          <FormattedMessage id={is404 ? '404' : 'WHOOPS'} />
        </h2>

        <p className="u-mT-sm">
          {message && (message)}
          {!message && (
            <FormattedMessage id={is404 ? 'PAGE_NOT_FOUND' : 'SOMETHING_WENT_WRONG'} />
          )}
        </p>

        <Button
          url="/"
          className="u-mT-md Button Button--primary"
          label={intl.formatMessage({ id: 'BACK_TO_START' })}
        />

      </div>
    </div>
  </div>
);

export const ErrorPage = injectIntl(ErrorPageComponent);
